import { parse } from 'date-fns';

import type { PointToPointTicketFormProps } from '~types/pointToPointTicket';

interface ValidateBeforeSubmitParams {
  data: PointToPointTicketFormProps;
  isSingleTrip: boolean;
}

export const isInvalidPlaceCondition = (data: PointToPointTicketFormProps) => {
  const { origin, destination } = data;

  if (!origin || !destination) {
    return false;
  }

  return origin.code === destination.code;
};

export const validateBeforeSubmit = ({ data, isSingleTrip }: ValidateBeforeSubmitParams) => {
  const {
    origin,
    destination,
    departureDate,
    arrivalDate,
    ages,
    outboundDepartureTime,
    inboundDepartureTime,
  } = data;

  if (!origin) {
    return {
      id: 'empty-origin',
      error: true,
      validationMessage: '출발지를 입력해주세요.',
    };
  }

  if (!destination) {
    return {
      id: 'empty-destination',
      error: true,
      validationMessage: '도착지를 입력해주세요.',
    };
  }

  if (!isSingleTrip && (!departureDate || !arrivalDate)) {
    return {
      id: 'empty-date',
      error: true,
      validationMessage: '일정을 선택해주세요.',
    };
  }

  if (
    !isSingleTrip &&
    departureDate === arrivalDate &&
    outboundDepartureTime &&
    inboundDepartureTime &&
    parse(outboundDepartureTime, 'HH:mm', new Date()) >=
      parse(inboundDepartureTime, 'HH:mm', new Date())
  ) {
    return {
      id: 'invalid-time',
      error: true,
      validationMessage: '오는 편 시간은 가는 편 시간 이후여야 합니다.',
    };
  }

  if (ages.length === 0) {
    return {
      id: 'empty-ages',
      error: true,
      validationMessage: '탑승인원을 입력해주세요.',
    };
  }

  return {
    id: undefined,
    error: false,
    validationMessage: '',
  };
};
